import { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';
import Customer from '../models/Customer';

type CustomerContextType = {
  customer: Customer;
  setCustomer: Dispatch<SetStateAction<any>>;
  successMessage: string | undefined;
  setSuccessMessage: Dispatch<SetStateAction<any>>;
}

const initCustomer: Customer = {
  firstName: '',
  name: '',
  registrationCode: '',
  email: '',
  country: '',
  preferredLanguage: '',
  servicesProvided: [],
  questionnaireTypesRequired: [],
  personType: ''
}

const CustomerContext = createContext<CustomerContextType>({
  customer: initCustomer,
  setCustomer: () => undefined,
  successMessage: undefined,
  setSuccessMessage: () => undefined,
})

export function CustomerContextProvider(props: { children: ReactNode }) {
  const [customer, setCustomer] = useState(initCustomer);
  const [successMessage, setSuccessMessage] = useState<string>();

  const providerValue = useMemo(() => (
    {customer, setCustomer, successMessage, setSuccessMessage}),
    [customer, successMessage]
  );

  return (
    <CustomerContext.Provider value={providerValue}>
      {props.children}
    </CustomerContext.Provider>
  )
}

export default CustomerContext;